export class DataCatalogPipelineResolvedGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "Array<DataCatalogPipelineResolvedGroupKeyInner>",
            "format": ""
        },
        {
            "name": "members",
            "baseName": "members",
            "type": "Array<DataCatalogPipelineResolvedDataset>",
            "format": ""
        },
        {
            "name": "catalogName",
            "baseName": "catalogName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "string",
            "format": ""
        },
        {
            "name": "outputColumns",
            "baseName": "outputColumns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineResolvedGroup.attributeTypeMap;
    }
    constructor() {
    }
}
